function resizeLogic() {
  const heightHeader = document.querySelector("header").offsetHeight
  document.querySelector(".header-fix").style.height = heightHeader + "px";

  if(window.innerWidth < 768 && document.querySelector('.usp-carousel')) {
    jQuery('.usp-carousel').slick({
      arrows: false,
      autoplay: true,
      dots: false,
      infinite: true,
      mobileFirst: true,
      slidesToScroll: 1,
      slidesToShow: 1,
    });
  }
}
let toggleMenu = () => {
  document.querySelector("#burger").classList.toggle('open');
  document.querySelector("#navigation-mobile > ul").classList.toggle('open');
};

// Range Slider Start

function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
  let [from, to] = getParsed(fromInput, toInput);
  if(isNaN(from)) {
    from = 0;
  }
  fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
  if (from < to) {
    fromSlider.value = from;
  }
  fromInput.value = from;
}

function controlToInput(toSlider, fromInput, toInput, controlSlider) {
  let [from, to] = getParsed(fromInput, toInput);
  if(isNaN(to)) {
    to = 0;
  }
  fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
  setToggleAccessible(toInput);

  if(to > from) {
    toSlider.value = to;
  }
  toInput.value = to;
}

function controlFromSlider(fromSlider, toSlider, fromInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
  if (from <= to) {
    fromSlider.value = from;
    fromInput.value = from;
  } else {
    fromInput.value = to;
    fromSlider.value = to;
  }
}

function controlToSlider(fromSlider, toSlider, toInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
  setToggleAccessible(toSlider);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
  } else {
    toInput.value = from;
    toSlider.value = from;
  }
}

function getParsed(currentFrom, currentTo) {
  const from = parseInt(currentFrom.value, 10);
  const to = parseInt(currentTo.value, 10);
  return [from, to];
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
  const rangeDistance = to.max-to.min;
  const fromPosition = from.value - to.min;
  const toPosition = to.value - to.min;
  controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
      ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
      ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} 100%)`;
}

function setToggleAccessible(currentTarget) {
  if (Number(currentTarget.value) <= 0 ) {
    currentTarget.style.zIndex = 2;
  } else {
    currentTarget.style.zIndex = 0;
  }
}

// Range Slider End

function getCartData() {
  fetch('/wp-admin/admin-ajax.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: 'action=fetch_cart_data',
  })
      .then(response => response.json())
      .then(data => {
        const cart_items_count = data.cart_items_count;
        const cart_total = data.cart_total;

        document.querySelector('#cart_items_count').innerHTML = cart_items_count;
        document.querySelector('.cart-amount').innerHTML = cart_items_count;
        document.querySelector('#cart_total').innerHTML = cart_total;
      })
      .catch(error => {
        console.error('Error:', error);
      });
}

document.addEventListener("DOMContentLoaded", function () { // Ready
  window.addEventListener("resize", resizeLogic);

  // Header Fix
  resizeLogic();

  // Burger click
  if(document.querySelector("#burger")) {
    document.querySelector("#burger").addEventListener("click", function () {
      toggleMenu();
    });
  }

  // Live Chat/Menu
  if(document.querySelector(".menu_livechat")) {
    document.querySelector(".menu_livechat").addEventListener("click", function () {
      document.querySelector("#chat-widget-container").classList.toggle("active");
      document.querySelector("#burger").click();
    });
  }

  if(document.querySelectorAll(".gallery-image")) {
    document.querySelectorAll(".gallery-image").forEach((el) => {
      el.addEventListener("click", function (e) {
        let ref = e.target.closest('.gallery-image').dataset.ref;
        document.querySelector(".gallery-image.active").classList.remove("active");
        e.target.closest('.gallery-image').classList.add("active");
        document.querySelector("#main-image img").src = ref;
      });
    });
  }

  // Mobile Menu Submenus
  if(document.querySelectorAll(".submenu-toggle")) {
    document.querySelectorAll(".submenu-toggle").forEach(function (el) {
      el.addEventListener("click", function (e) {
        el.classList.toggle("open");
        el.nextElementSibling.classList.toggle("open");
      });
    });
  }

  // Menu Back Buttons
  if(document.querySelectorAll(".back-btn")) {
    document.querySelectorAll(".back-btn").forEach(function (el) {
      el.addEventListener("click", function () {
        document.querySelectorAll(".mega-menu.open").forEach(function (el) {
          el.classList.remove("open");
        });

        document.querySelectorAll(".submenu-toggle.open").forEach(function (el) {
          el.classList.remove("open");
        });

        document.querySelectorAll(".nav-link.open").forEach(function (el) {
          el.classList.remove("open");
        });
      });
    });
  }

  // Filter button spinner
  if(document.querySelectorAll(".filter-btn")) {
    document.querySelectorAll(".filter-btn").forEach(function (el) {
      el.addEventListener("click", function () {
        el.querySelector('svg').classList.add("button-spinner");
        el.classList.add("spinner");
      });
    });
  }

  // mobile filter toggle button
  if(document.querySelectorAll("button.filter-toggle")) {
    document.querySelectorAll("button.filter-toggle").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        el.classList.toggle("open");
        let parent = el.closest("#mobile-filter-controls");
        let slider = parent.previousElementSibling;
        parent.classList.toggle("open");
        slider.classList.toggle("open");
      });
    });
  }

  // Trigger Filtering on sort option change
  if(document.querySelector("#sort-ref")) {
    document.querySelector("#sort-ref").addEventListener("change", function () {
      document.querySelector(".sort-filter-hidden").value = document.querySelector("#sort-ref").value;
      document.querySelector(".filter-btn").classList.add("spinner");
      document.querySelector(".filter-form").submit();
    })
  }

  // Trigger Filtering on sort option change mobile
  if(document.querySelector("#custom-sort-ref, #mobile-custom-sort-ref")) {
    document.querySelector("#custom-sort-ref, #mobile-custom-sort-ref").addEventListener("change", function (el) {
      document.querySelector(".sort-filter-hidden").value = el.target.options[el.target.selectedIndex].value;
      document.querySelector(".filter-btn").classList.add("spinner");
      document.querySelector(".filter-form").submit();
    })
  }

  // Show register account
  if(document.querySelector(".create-account-btn")) {
    document.querySelector(".create-account-btn").addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("#customer_login .col-1").classList.add("hidden");
      document.querySelector("#customer_login .col-2").classList.add("show");
    })
  }

  // Show signin account
  if(document.querySelector(".signin-btn")) {
    document.querySelector(".signin-btn").addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("#customer_login .col-1").classList.remove("hidden");
      document.querySelector("#customer_login .col-2").classList.remove("show");
    })
  }

  // Custom arrows
  if(document.querySelector(".custom-next")) {
    document.querySelector(".custom-next").addEventListener("click", function () {
      let currentActive = document.querySelector("img.flex-active");
      let currentLi = currentActive.closest("li");
      let nextLi = currentLi.nextElementSibling;
      if (nextLi) {
        nextLi.querySelector("img").click();
      }
    })
  }

  if(document.querySelector(".custom-prev")) {
    document.querySelector(".custom-prev").addEventListener("click", function () {
      let currentActive = document.querySelector("img.flex-active");
      let currentLi = currentActive.closest("li");
      let nextLi = currentLi.previousElementSibling;
      if (nextLi) {
        nextLi.querySelector("img").click();
      }
    })
  }

  if(document.querySelector("form.cart")) {
    document.querySelector("form.cart").addEventListener("click", function (e) {
      // Get current quantity values
      let qty = document.querySelector("form.cart .qty");
      let val = parseFloat(qty.value);
      let max = parseFloat(qty.getAttribute("max"));
      let min = parseFloat(qty.getAttribute("min"));
      let step = parseFloat(qty.getAttribute("step"));

      // Change the value if plus or minus
      if (e.target.classList.contains("plus")) {
        if (max && max <= val) {
          qty.value = max;
        } else {
          qty.value = val + step;
        }
      } else {
        if (e.target.classList.contains("minus")) {
          if (min && min >= val) {
            qty.value = min;
          } else if (val > 1) {
            qty.value = val - step;
          }
        }
      }
    })
  }

  if(document.querySelector("#further-desc button.read-more")) {
    document.querySelectorAll("#further-desc button.read-more").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        let full = el.parentNode.querySelector("span.full");
        let preview = el.parentNode.querySelector("span.preview");

        full.classList.toggle("d-none");
        preview.classList.toggle("d-none");

        this.classList.toggle("expanded");
        if (this.classList.contains("expanded")) {
          this.innerHTML = "Read less <i class='fa-solid fa-ellipsis'></i>";
        } else {
          this.innerHTML = "Read more <i class='fa-solid fa-ellipsis'></i>";
        }
      })
    })
  }

  if(document.querySelector("#cat-description button.read-more")) {
    document.querySelectorAll("#cat-description button.read-more").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        let full = el.parentNode.querySelector("span.full");
        let preview = el.parentNode.querySelector("span.preview");

        full.classList.toggle("d-none");
        preview.classList.toggle("d-none");

        this.classList.toggle("expanded");
        if (this.classList.contains("expanded")) {
          this.innerHTML = "Read less <i class='fa-solid fa-ellipsis'></i>";
        } else {
          this.innerHTML = "Read more <i class='fa-solid fa-ellipsis'></i>";
        }
      })
    })
  }

  if(document.querySelector("#mobile-product-info button.read-more")) {
    document.querySelectorAll("#mobile-product-info button.read-more").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        let full = el.parentNode.querySelector("div.full");
        let preview = el.parentNode.querySelector("span.preview");

        full.classList.toggle("d-none");
        preview.classList.toggle("d-none");

        this.classList.toggle("expanded");
        if (this.classList.contains("expanded")) {
          this.innerHTML = "Read less <i class='fa-solid fa-ellipsis'></i>";
        } else {
          this.innerHTML = "Read more <i class='fa-solid fa-ellipsis'></i>";
        }
      })
    })
  }

  // Measurements check
  if(!document.querySelector('#Measurements-ref') && document.querySelector('#btn-measurements')) {
    document.querySelector('#btn-measurements').style.display = 'none';
  }

  // ==============================
  // MULTIPLE SUPPLIER FUNCTIONS
  // ==============================

  if (document.querySelectorAll(".carousel-category_gallery").length > 0) {
    document.querySelectorAll(".carousel-category_gallery").forEach(function (el) {

    })

  jQuery('.carousel-category_gallery').slick({
      arrows: true,
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24px" height="16px"><path fill="#FFFFFF" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>Next</button>',
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24px" height="16px"><path fill="#FFFFFF" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>Previous</button>',
      dots: false,
      infinite: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          }
        },
      ],
      slidesToScroll: 1,
      slidesToShow: 2,
    });
  }

  if(document.querySelector('.accordion-button')) {
    document.querySelectorAll('.accordion-button').forEach(function (el) {
      el.addEventListener('click', function () {
        el.classList.toggle('hide-text');
        el.parentNode.parentNode.querySelector('.accordion-collapse').classList.toggle('show');
        el.parentNode.querySelector('.accordion-button:before').style.transform = 'rotate(180deg)'
      });
    });
  }

  // Range Slider

  if(document.querySelector('.range_container')) {
    document.querySelectorAll('.range_container').forEach(function (el) {
      const fromSlider = el.querySelector('.fromSlider');
      const toSlider = el.querySelector('.toSlider');
      const fromInput = el.querySelector('.fromInput');
      const toInput = el.querySelector('.toInput');
      fillSlider(fromSlider, toSlider, '#C6C6C6', '#90eb6b', toSlider);
      setToggleAccessible(toSlider);

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

    });
  }

  // Product Filters

  if(document.querySelector('.product-filter')) {
    document.querySelectorAll('.product-filter-glazing-type-display').forEach(function (el) {
        el.addEventListener(('change'), function () {
          if(el.checked) {
            document.querySelector('#product-filter-glazing-type').value += el.value + ',';
          } else {
            document.querySelector('#product-filter-glazing-type').value = document.querySelector('#product-filter-glazing-type').value.replace(el.value + ',', '');
          }
        });
    })
    document.querySelectorAll('.product-filter-number-of-doors-display').forEach(function (el) {
      el.addEventListener(('change'), function () {
        if(el.checked) {
          document.querySelector('#product-filter-number-of-doors').value += el.value + ',';
        } else {
          document.querySelector('#product-filter-number-of-doors').value = document.querySelector('#product-filter-number-of-doors').value.replace(el.value + ',', '');
        }
      });
    })
    document.querySelectorAll('.product-filter').forEach(function (el) {
      el.addEventListener(('change'), function () {
        document.querySelector('#loading-mask-container').style = 'display: flex';
        document.querySelector('form.product-filters').submit();
      });
    });
    document.querySelectorAll('.fromSlider').forEach(function (el) {
      el.addEventListener(('mouseup'), function () {
        document.querySelector('#loading-mask-container').style = 'display: flex';
        document.querySelector('form.product-filters').submit();
      });
    });
    document.querySelectorAll('.toSlider').forEach(function (el) {
      el.addEventListener(('mouseup'), function () {
        document.querySelector('#loading-mask-container').style = 'display: flex';
        document.querySelector('form.product-filters').submit();
      });
    });
    document.querySelector('#clear-filters').addEventListener(('mouseup'), function () {
      document.querySelector('#loading-mask-container').style = 'display: flex';
    });
  }

  if(document.querySelector('#mobile-toggle-filters')) {
    document.querySelector('#mobile-toggle-filters').addEventListener(('click'), function () {
      document.querySelector('#filters-sidebar-container').classList.toggle('closed');
      document.querySelector('#mobile-toggle-filters').classList.toggle('open');

      if(document.querySelector('#filters-sidebar-container').classList.contains('closed')) {
        document.querySelector('#mobile-toggle-filters').innerHTML = 'Filter Products';
      } else {
        document.querySelector('#mobile-toggle-filters').innerHTML = 'Hide Filters';
      }
    });
  }

  if(window.location.href.includes('?')) {
    window.scrollTo(0, document.querySelector('#filters-products-grid').offsetTop);
  }

  if(document.querySelector('#cart_items_count') && document.querySelector('#cart_total')) {
    getCartData();
    jQuery(document).on('updated_cart_totals', () => {
        getCartData();
    });
  }
});

(function () {
  function query (selector) {
    return Array.from(document.querySelectorAll(selector));
  }

  function pointerenterHandler (event) {
    if (!preloadedUrls.has(this.href)) {
      prefetcher.onload = function() {
        preloadedUrls.add(this.href);
        observer.unobserve(this);
      };
      prefetcher.href = this.href;
    }

    this.addEventListener('pointerleave', pointerleaveHandler);
    this.addEventListener('pointerdown', pointerdownHandler);
  }

  function pointerleaveHandler (event) {
    prefetcher.removeAttribute('href');

    this.removeEventListener('pointerleave', pointerleaveHandler);
    this.removeEventListener('pointerdown', pointerdownHandler);
  }

  function pointerdownHandler (event) {
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      const speculationTag = document.createElement('script');
      speculationTag.textContent = JSON.stringify({ prerender: [{ source: 'list', urls: [this.href] }] });
      speculationTag.type = 'speculationrules';
      document.head.appendChild(speculationTag);
    }
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const link = entry.target;
      if (entry.isIntersecting) {
        link.addEventListener('pointerenter', pointerenterHandler);
      }
      else {
        link.removeEventListener('pointerenter', pointerenterHandler);
      }
    });
  });

  const preloadedUrls = new Set();

  const prefetcher = document.createElement('link');
  prefetcher.as = prefetcher.relList.supports('prefetch') ? 'document' : 'fetch';
  // as=document is Chromium-only and allows cross-origin prefetches to be
  // usable for navigation. They call it “restrictive prefetch” and intend
  // to remove it: https://crbug.com/1352371
  // Safari doesn't support `document`
  prefetcher.rel = prefetcher.relList.supports('prefetch') ? 'prefetch' : 'preload';
  document.head.appendChild(prefetcher);

  query('a[href]:not([href^="#"]').forEach(item => observer.observe(item));
})();